module.exports = __webpack_public_path__ + "static/media/iphone-img2.cfbe4efc.png";